import { getPrincipal } from "@/principal";
import { type QueryKey } from "@tanstack/react-query";

export function keyWithPrincipal(key: QueryKey): QueryKey {
    const principal = getPrincipal();
    return ["principal", principal, ...key];
}
